import './StoreEditPage.less';

export const prefix = 'bm-p-store-edit';

export { default } from './StoreEditPage';
